import { Component, Injector, OnInit } from '@angular/core';
import { ComponentContextService, DataFormBase, EventData, FormSchemaBase, SameValueValidator, TextControlSchema, UserService, UserV5Service } from 'tnx-shared';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    providers: [ComponentContextService]
})
export class ResetPasswordComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        protected _userV5Service: UserV5Service,
        public _userService: UserService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._userV5Service;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'passwordHash',
                label: 'Mật khẩu',
                dataFormat: 'password',
                mdWidth: 12,
                required: true
            }),
            new TextControlSchema({
                field: 'confirmPassword',
                label: 'Gõ lại Mật khẩu',
                dataFormat: 'password',
                validators: [new SameValueValidator(['passwordHash'], 'Mật khẩu phải giống nhau')],
                mdWidth: 12,
                required: true
            })
        ];
    }

    getPromiseActionInsert() {
        return this._userService.resetPassword(this.model.data);
    }

    getPromiseActionUpdate() {
        return this._userService.resetPassword(this.model.data);
    }

    async onFormInitialized(constrols: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
        if (this.model.data.id) {

        } else {
        }
    }

    async modifyDetailData(data) {
        data.passwordHash = '';
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }

}
